import { render } from "./invoices-payment.vue?vue&type=template&id=6bf4b122"
import script from "./invoices-payment.vue?vue&type=script&lang=js"
export * from "./invoices-payment.vue?vue&type=script&lang=js"

import exportComponent from "/home/source/apps.macrofox.fr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__